import { translate } from '~/utils/translate'

export const getSentences = () => [
  translate('PROCESSING_SCREEN_SENTENCE_1'),
  translate('PROCESSING_SCREEN_SENTENCE_2'),
  translate('PROCESSING_SCREEN_SENTENCE_3'),
]
